import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft'

@Component({
  selector: 'cft-back-button',
  templateUrl: './back-button.component.html',
  styles: [':host { display: block }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {
  /**
   * Path of the button
   * @note If you need to pass query params, use the associated `queryParams` property as `path` will be url encoded
   */
  @Input() path!: string
  @Input() queryParams?: Record<string, unknown>
  @Input() light = false

  readonly backIcon = faChevronLeft
}
